import AlertDialogPrompt from "../../types/system/AlertDialogPrompt";
import { MockPromise } from "./MockPromise";
import { MockPromiseWrapper } from "./MockPromiseWrapper";

export enum AlertTypes {
    Alert = "alert",
    Confirm = "confirm",
    Prompt = "prompt"
}

export type AlertStyleColour = "red" | "green" | "blue" | "yellow";

export type AlertType = AlertTypes.Alert | AlertTypes.Confirm | AlertTypes.Prompt;

export interface AlertResult {
    response: boolean;
    buttonClicked: string;
    promptResults?: AlertDialogPrompt[];
}

interface AlertEntry {
    type?: AlertType,
    width?: number,
    title?: string,
    icon?: string,
    styleColor?: AlertStyleColour,
    text?: string,
    prompts?: AlertDialogPrompt[],
    buttons?: string[],
    okText?: string,
    cancelText?: string,
}

export class Alert implements AlertEntry {
    type: AlertType;
    width?: number;
    title: string;
    icon?: string;
    styleColor?: AlertStyleColour;
    text: string;
    prompts?: AlertDialogPrompt[];
    buttons?: string[];
    okText?: string;
    cancelText?: string;
    promiseWrapper: MockPromiseWrapper<AlertResult>;

    constructor(entry: AlertEntry) {
        this.type = entry.type ?? AlertTypes.Alert;
        this.width = entry.width;
        this.title = entry.title ?? "";
        this.icon = entry.icon;
        this.styleColor = entry.styleColor;
        this.text = entry.text ?? "";
        this.prompts = entry.prompts;
        this.buttons = entry.buttons;
        this.okText = entry.okText;
        this.cancelText = entry.cancelText;
        this.promiseWrapper = new MockPromiseWrapper<AlertResult>(
            `alert-${Date.now()}`,
            `Alert: ${this.title}`,
        );
    }
}

export default AlertEntry;